import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL || import.meta.env.REACT_APP_BACKEND_URL;

export const addToReadLater = async (linkData, token) => {
  try {
    if (!token) {
      throw new Error('User must be logged in to save links');
    }

    const headers = { Authorization: `Bearer ${token}` };
    
    const response = await axios.post(`${API}/api/read-later`, linkData, { headers });
    
    return response.data;
  } catch (error) {
    console.error('Error adding to read later:', error);
    throw error;
  }
};

export const showReadLaterNotification = (title = 'Link saved!', message = 'Added to your Read Later list') => {
  // Create notification element
  const notification = document.createElement('div');
  notification.innerHTML = `
    <div class="flex items-center space-x-3">
      <span class="text-2xl">📚</span>
      <div>
        <div class="font-semibold text-white">${title}</div>
        <div class="text-emerald-100 text-sm">${message}</div>
      </div>
    </div>
  `;
  notification.className = 'fixed top-4 right-4 bg-emerald-500 text-white px-6 py-4 rounded-lg shadow-xl z-50 min-w-[300px] transition-all duration-300 transform translate-x-full';
  
  document.body.appendChild(notification);
  
  // Animate in
  setTimeout(() => {
    notification.classList.remove('translate-x-full');
  }, 100);
  
  // Animate out and remove
  setTimeout(() => {
    notification.classList.add('translate-x-full');
    setTimeout(() => {
      if (notification.parentNode) {
        document.body.removeChild(notification);
      }
    }, 300);
  }, 3000);

  // Trigger navbar refresh by dispatching a custom event
  window.dispatchEvent(new CustomEvent('readLaterUpdated'));
};

export const handleLinkPreviewClick = async (linkPreview, postId, sourceType = 'post', token, user) => {
  try {
    if (!token || !user) {
      // Show login prompt
      const loginNotification = document.createElement('div');
      loginNotification.innerHTML = `
        <div class="flex items-center space-x-3">
          <span class="text-2xl">🔒</span>
          <div>
            <div class="font-semibold text-white">Login Required</div>
            <div class="text-blue-100 text-sm">Please log in to save links</div>
          </div>
        </div>
      `;
      loginNotification.className = 'fixed top-4 right-4 bg-blue-500 text-white px-6 py-4 rounded-lg shadow-xl z-50 min-w-[300px] transition-all duration-300 transform translate-x-full';
      
      document.body.appendChild(loginNotification);
      
      setTimeout(() => {
        loginNotification.classList.remove('translate-x-full');
      }, 100);
      
      setTimeout(() => {
        loginNotification.classList.add('translate-x-full');
        setTimeout(() => {
          if (loginNotification.parentNode) {
            document.body.removeChild(loginNotification);
          }
        }, 300);
      }, 3000);
      
      return;
    }

    // Prepare link data
    const linkData = {
      url: linkPreview.url,
      title: linkPreview.title,
      description: linkPreview.description,
      image: linkPreview.image,
      domain: linkPreview.domain,
      source_post_id: postId,
      source_type: sourceType
    };

    // Add to read later
    await addToReadLater(linkData, token);
    
    // Show success notification
    showReadLaterNotification(
      'Link saved! 📚',
      `Added "${linkPreview.title || 'Link'}" to Read Later`
    );
    
  } catch (error) {
    console.error('Error handling link preview click:', error);
    
    // Show error notification
    const errorNotification = document.createElement('div');
    errorNotification.innerHTML = `
      <div class="flex items-center space-x-3">
        <span class="text-2xl">⚠️</span>
        <div>
          <div class="font-semibold text-white">Save Failed</div>
          <div class="text-red-100 text-sm">Unable to save link. Please try again.</div>
        </div>
      </div>
    `;
    errorNotification.className = 'fixed top-4 right-4 bg-red-500 text-white px-6 py-4 rounded-lg shadow-xl z-50 min-w-[300px] transition-all duration-300 transform translate-x-full';
    
    document.body.appendChild(errorNotification);
    
    setTimeout(() => {
      errorNotification.classList.remove('translate-x-full');
    }, 100);
    
    setTimeout(() => {
      errorNotification.classList.add('translate-x-full');
      setTimeout(() => {
        if (errorNotification.parentNode) {
          document.body.removeChild(errorNotification);
        }
      }, 300);
    }, 3000);
  }
};